import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Box, List, ListItem, IconButton } from '@material-ui/core';
import MDashboardIcon from '@material-ui/icons/Home';
import MAccountingIcon from '@material-ui/icons/Assessment';
import MFleetManagementIcon from '@material-ui/icons/InsertDriveFile';
import MAssetManagementIcon from '@material-ui/icons/Settings';
import OfflineBoltOutlinedIcon from '@material-ui/icons/OfflineBolt';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShipping';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import ComputerOutlinedIcon from '@material-ui/icons/Computer';
import DescriptionOutlinedIcon from '@material-ui/icons/Description';
import SubjectIcon from '@material-ui/icons/Subject';

export const Wrapper = styled(Box)`
  ${({ theme, hide, width }) => `
    display: ${hide === 'true' ? 'none' : width ? 'block' : 'none'};
    position: fixed;
    height: 100vh;
    margin-right: 20%;
    background: ${theme.palette.backgrounds.main};
    border-right: 1px solid #E2E2E2;
    width: ${width && '16%'};
    z-index: 999;
    transition: display 10s;
    // width: 6%;
    @media (max-width: 600px){
      width: 16%;
      display : none;
      // border: 1px solid blue;
      // display: flex;
      flex-direction: column;
    }
svg{
  cursor: pointer;
}
    ${theme.breakpoints.down('lg')} {
      img {
        // width: 140px;
      }
    }
  `}
`;

export const Logo = styled.img`
  display: block;
  margin: auto;
  width: 207px;
`;

export const BusinessSummaryWrapper = styled(Box)`
  ${({ theme, width }) => `
  flex-direction : ${width ? 'row' : 'column'};
  margin-top: 8%;
  display: flex;
  align-items: center;
  width: 100%;
  svg {
    margin: ${width ? '1rem 0.5rem' : '.5rem 0'};
  }

  padding-left: ${width ? '0.5rem' : '0'};
  @media (max-width: 960px){
    flex-direction: column;
    // border: 1px solid pink;
  }
`}
`;

// .5rem 0

export const MenuItems = styled(List)`
  ${({ theme }) => `
    margin-top: 10% !important;
`}
`;

export const MenuItem = styled(ListItem)`
  ${({ theme, isactive, width }) => `
    ${theme.mixins.makeResponsive({ theme, fontSize: 18, lineHeight: 20 })}
    font-weight: ${isactive === 'true' ? '700' : '400'};
    text-transform: capitalize;
    cursor: pointer;
    position: relative;
    padding: 0 !important;
    margin-top: 2%;
    
    // &:after {
    //   content: '';
    //   display: ${isactive === 'true' ? 'block' : 'none'};
    //   position: absolute;
    //   right: 0;
    //   background: ${theme.palette.secondary.main};
    //   height: 100%;
    //   width: 6px;
    //   border-radius: 3px 0 0 3px;
    //   opacity : ${width ? 1 : 0};
    // }
  `}
`;

export const LinkTitle = styled.span`
  ${({ theme, width }) => `
  display : ${width ? 'inline' : 'none'};
  @media (max-width: 960px){
    display: none;
  }
`}
`;

export const MenuLink = styled(Link)`
  ${({ theme, isactive }) => `
    margin: 0 2%;
    width: 100%;
    height: 100%;
    background: ${
      isactive === 'true' ? theme.palette.secondary.light2 : 'white'
    };
    border-radius: 5px;
    text-decoration: none;
    color: ${
      isactive === 'true'
        ? theme.palette.secondary.main
        : theme.palette.dark.main
    };
    &:hover {
      background: ${theme.palette.secondary.light2};
    }
    &:before {
      content: '';
      display: block;
      background: ${
        isactive === 'true' ? theme.palette.secondary.light2 : 'transparent'
      };
      position: absolute;
      left: -150px;
      height: 100%;
      width: 200px;
    }  
  `}
`;

export const MenuButton = styled(IconButton)`
  ${({ theme, width }) => `
    margin-right: ${width ? '7%' : 0};
    padding: ${width ? '8% 0' : '12px'};
    padding-left: ${width ? '10%' : '12px'};
    width: ${width ? 'auto' : '90%'};
    &:hover{
      background : none;
    }
  `}
`;

const iconStyle = ({ theme, isactive }) => `
    color: ${isactive === 'true' ? '#2898A4' : '#737373'};
    margin-top: -3px;
 
`;

export const DashboardIcon = styled(MDashboardIcon)`
  ${iconStyle}
`;
export const AccountingIcon = styled(MAccountingIcon)`
  ${iconStyle}
`;
export const FleetManagementIcon = styled(MFleetManagementIcon)`
  ${iconStyle}
`;
export const AssetManagementIcon = styled(MAssetManagementIcon)`
  ${iconStyle}
`;
export const QuickActionsIcon = styled(OfflineBoltOutlinedIcon)`
  ${iconStyle}
`;

export const FleetIcon = styled(LocalShippingOutlinedIcon)`
  ${iconStyle}
`;
export const BusinessDirectoryIcon = styled(BusinessCenterIcon)`
  ${iconStyle}
`;
export const AssetsIcon = styled(ComputerOutlinedIcon)`
  ${iconStyle}
`;
export const DocGenIcon = styled(DescriptionOutlinedIcon)`
  ${iconStyle}
`;
export const PayrollIcon = styled(SubjectIcon)`
  ${iconStyle}
`;
